"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Eris = void 0;
const Tags_1 = require("../Tags");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const AresCardManifest_1 = require("./AresCardManifest");
const PlaceHazardTile_1 = require("../../deferredActions/PlaceHazardTile");
const SelectOption_1 = require("../../inputs/SelectOption");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const LogHelper_1 = require("../../LogHelper");
const Card_1 = require("../Card");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRenderItem_1 = require("../render/CardRenderItem");
const Size_1 = require("../render/Size");
const TileType_1 = require("../../TileType");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
class Eris extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.ERIS,
            tags: [Tags_1.Tags.BUILDING],
            initialActionText: 'Draw an Ares card',
            startingMegaCredits: 46,
            metadata: {
                cardNumber: 'R47',
                description: 'You start with 46 M€. As your first action, draw an Ares card.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br.br;
                    b.megacredits(46).nbsp().cards(1).secondaryTag(CardRenderItem_1.AltSecondaryTag.ARES);
                    b.corpBox('action', (ce) => {
                        ce.action('Place a new hazard tile adjacent to NO OTHER TILE, OR remove a hazard tile to gain 1 TR.', (eb) => {
                            eb.empty().startAction.plus().hazardTile().slash().minus().hazardTile().colon().tr(1, Size_1.Size.SMALL);
                        });
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    initialAction(player) {
        if (player.game.gameOptions.aresExtension) {
            this.drawAresCard(player);
        }
        return undefined;
    }
    canAct(player) {
        const game = player.game;
        const availableSpaces = this.getAvailableSpaces(player, game);
        const hazardSpaces = Eris.getAllUnprotectedHazardSpaces(game);
        if (availableSpaces.length === 0 && hazardSpaces.length === 0)
            return false;
        return true;
    }
    action(player) {
        const game = player.game;
        const orOptions = new OrOptions_1.OrOptions();
        const availableSpaces = this.getAvailableSpaces(player, game);
        const hazardSpaces = Eris.getAllUnprotectedHazardSpaces(game);
        if (availableSpaces.length > 0) {
            orOptions.options.push(new SelectOption_1.SelectOption('Place a hazard tile adjacent to no other tile', 'Select', () => {
                const title = 'Select space next to no other tile for hazard';
                game.defer(new PlaceHazardTile_1.PlaceHazardTile(player, game, title, availableSpaces));
                return undefined;
            }));
        }
        const canAffordReds = !PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS) || player.canAfford(constants_1.REDS_RULING_POLICY_COST);
        if (hazardSpaces.length > 0 && canAffordReds) {
            orOptions.options.push(new SelectOption_1.SelectOption('Remove a hazard tile to gain 1 TR', 'Select', () => {
                return new SelectSpace_1.SelectSpace('Select hazard tile to remove', Eris.getAllUnprotectedHazardSpaces(game), undefined, (space) => {
                    space.tile = undefined;
                    player.increaseTerraformRatingSteps(1);
                    LogHelper_1.LogHelper.logTRChange(player, 1);
                    return undefined;
                });
            }));
        }
        if (orOptions.options.length === 1)
            return orOptions.options[0].cb();
        return orOptions;
    }
    drawAresCard(player) {
        player.drawCard(1, {
            include: (card) => AresCardManifest_1.ARES_CARD_MANIFEST.projectCards.findByCardName(card.name) !== undefined,
        });
        return undefined;
    }
    getAvailableSpaces(player, game) {
        return game.board.getAvailableSpacesOnLand(player)
            .filter(((space) => space.tile === undefined))
            .filter((space) => {
            const adjacentSpaces = game.board.getAdjacentSpaces(space);
            return adjacentSpaces.filter((space) => space.tile !== undefined).length === 0;
        });
    }
    static getAllUnprotectedHazardSpaces(game) {
        return game.board.spaces.filter((space) => space.tile && TileType_1.HAZARD_TILES.has(space.tile.tileType) && space.tile.protectedHazard === false);
    }
}
exports.Eris = Eris;
//# sourceMappingURL=Eris.js.map